<template>
  <div class="spinners" v-if="spinners && false">
    <atom-spinner :animation-duration="1000" :size="100" color="#ff1d5e" />
  </div>
  <div class="error-alert bg-danger" v-if="controlPLC?.errorStatus">
    <atom-spinner :animation-duration="1000" :size="30" color="white" />
    <span>{{ `${$t('errorCode')} ${controlPLC?.errorCode}` }} :
      {{ $t(`spr.errorDesc.${controlPLC?.errorCode}`) }}</span>
    <atom-spinner :animation-duration="1000" :size="30" color="white" />
  </div>
  <header v-if="this.auth.authority">
    <ul>
      <li @click="collapse"><i class="fas fa-bars btn-aside zoom"></i></li>
    </ul>
    <div class="fs-6">
      <p style="width: 125px" class="text-center" v-if="license">
        <span v-if="this.auth.tecnicalPersonal">{{ `${$t('developer')} ${this.$store.state.systemDate.slice(10,
          19)}` }}</span>
        <span v-else>{{ this.$store.state.systemDate }}</span>
      </p>
      <p v-else>
        <span class="btn bg-danger text-white fs-5">{{ $t('copyCard') }}</span>
      </p>
    </div>
    <ul>
      <li id="fsBtn" v-if="this.authority && this.machineNetwork" @click="logout()">
        <!-- style="color:#5396da;" -->
        <i class="fas fa-sign-out-alt"></i>
      </li>
      <li id="fsBtn" v-if="!this.authority && this.machineNetwork"
        @click="this.$router.push({ query: { login: 'login' } })">
        <i class="fas fa-sign-in-alt"></i>
      </li>
      <li>
        <span class="fs-3 opacity-75" v-if="this.machineNetwork">{{ this.config?.sub_id }}</span>
      </li>
      <li id="fsBtn" @click="fullScreen">
        <i class="fas fa-expand-arrows-alt zoom"></i>
      </li>
    </ul>
  </header>

  <nav v-if="this.auth.authority">
    <div class="logo-details big">
      <div id="logo-small" class="logo d-none">
        <img src="@/assets/media/img/logo.png" alt="" style="object-fit: contain" />
      </div>
      <div id="logo-big" class="logo">
        <img src="@/assets/media/img/logo2.png" alt="" style="object-fit: contain" />
      </div>
    </div>
    <ul class="nav-list">
      <li class="nav-item">
        <div class="input-area-single">
          <select class="input" name="mixtureLiter" id="mixtureLiter" v-model="selected_machine">
            <option v-for="(item, index) in this.$store.state.machine_data" :key="index" :value="item.machine_id">
              {{ item.code }}
            </option>
          </select>
        </div>
      </li>
      <li class="nav-item">
        <a class="nav-link">
          <i class="fas fa-home"></i>
          <router-link class="nav-title fw-bold" to="/">{{ $t('nav.home') }}</router-link>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link">
          <i class="fas fa-plug"></i>
          <router-link class="nav-title fw-bold" to="/energy">{{ $t('nav.powerManagementList') }}</router-link>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link">
          <i class="fas fa-exclamation-circle"></i>
          <router-link class="nav-title fw-bold" to="/errors">{{ $t('nav.alerts') }}</router-link>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link">
          <i class="fas fa-spinner"></i>
          <router-link class="nav-title fw-bold" to="/tracking/components">{{ $t('nav.calibrations') }}</router-link>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" @click="dropdown($event)">
          <i class="fas fa-lock-open"></i>
          <i class="fas fa-chevron-down arrow"></i>
          <span class="nav-title fw-bold">{{ $t('nav.n_tracking') }}</span>
        </a>
        <ul class="sub-nav">
          <li class="nav-item">
            <a class="nav-link">
              <i class="fas fa-chart-line"></i>
              <router-link class="nav-title fw-bold" to="/tourMonitor">{{ $t('nav.tourMonitor') }}</router-link>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link">
              <i class="fas fa-chart-line"></i>
              <router-link class="nav-title fw-bold" to="/chargeMonitor">{{ $t('nav.chargeMonitor') }}</router-link>
            </a>
          </li>
        </ul>
      </li>
      <hr v-if="this.auth?.authority">
      <li class="nav-item" v-if="this.auth?.authority">
        <a class="nav-link">
          <i class="fas fa-microchip"></i>
          <router-link class="nav-title fw-bold" to="/panel/tracking/follow">{{ $t('nav.n_tracking', { name: 'PLC' })
          }}</router-link>
        </a>
      </li>
      <li class="nav-item" v-if="this.auth?.authority">
        <a class="nav-link" @click="dropdown($event)">
          <i class="fas fa-lock-open"></i>
          <i class="fas fa-chevron-down arrow"></i>
          <span class="nav-title fw-bold">{{ $t('nav.n_control', { name: $t('general') }) }}</span>
        </a>
        <ul class="sub-nav">
          <li class="nav-item">
            <a class="nav-link">
              <i class="fas fa-spinner"></i>
              <router-link class="nav-title fw-bold" to="/tracking/system">{{ $t('nav.n_control', {
                name:
                  $t('system')
              }) }}</router-link>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link">
              <i class="fas fa-spinner"></i>
              <router-link class="nav-title fw-bold" to="/tracking/license">{{ $t('license.license') }}</router-link>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link">
              <i class="fas fa-spinner"></i>
              <router-link class="nav-title fw-bold" to="/tracking/network">{{ $t('network') }}</router-link>
            </a>
          </li>
          <li class="nav-item" v-if="this.auth?.authority">
            <a class="nav-link">
              <i class="fas fa-spinner"></i>
              <router-link class="nav-title fw-bold" to="/calibration/ports">{{ $t('nav.n_control', {
                name: $t('port')
              }) }}</router-link>
            </a>
          </li>
        </ul>
      </li>
    </ul>
    <div class="nav-profil">
      <div class="profil-img" @click="userSettings">
        <img src="@/assets/media/img/logo.png" alt="" style="object-fit: contain" />
      </div>

      <p class="profil-name line-limit">{{ 'www.itechrobotics.com.tr' }}</p>
    </div>
  </nav>

  <main class="container-xxxl" v-if="this.auth.authority">
    <div class="content">
      <div class="main-header">
        <p class="page-name">{{ this.breadcrumb[this.breadcrumb.length - 1] }}</p>
        <ul class="breadcrumb">
          <li><a href="/">{{ $t('nav.home') }}</a></li>
          <li v-for="(item, index) in this.breadcrumb" :key="index">{{ item }}</li>
        </ul>
      </div>
      <router-view @breadcrumb="breadcrumb = $event" />
    </div>
    <div class="perde" v-if="navOptionsBarShow" @click="navOptionsBar0()"></div>
    <div id="navOptionsBar" class="nav-options-bar">
      <div class="door-handle" @click="navOptionsBar0()">
        <i class="fas fa-cog bg-transparent"></i>
      </div>
      <div class="content">
        <div class="text-center mb-2">
          <p class="btn btn-sm btn-success">{{ `${$t('version')}: ${this.version}` }}</p>
        </div>
        <div class="nob-header">
          <p class="title mb-2 fw-bold">{{ $t('systemConf') }}</p>
        </div>
        <div class="row justify-content-center my-3">
          <div class="col-4 lang-box mb-2" @click="change_lang('tr')">
            <img src="@/assets/media/img/lang/tr.png" alt="" class="user-img-sm"/>
          </div>
          <div class="col-4 lang-box mb-2" @click="change_lang('az')">
            <img src="@/assets/media/img/lang/az.png" alt="" class="user-img-sm"/>
          </div>
          <div class="col-4 lang-box mb-2" @click="change_lang('en')">
            <img src="@/assets/media/img/lang/en.png" alt="" class="user-img-sm"/>
          </div>
          <div class="col-4 lang-box mb-2" @click="change_lang('ru')">
            <img src="@/assets/media/img/lang/ru.png" alt="" class="user-img-sm"/>
          </div>
          <div class="col-4 lang-box mb-2" @click="change_lang('de')">
            <img src="@/assets/media/img/lang/de.png" alt="" class="user-img-sm"/>
          </div>
          <div class="col-4 lang-box mb-2" @click="change_lang('ar')">
            <img src="@/assets/media/img/lang/ar.png" alt="" class="user-img-sm"/>
          </div>
        </div>
        <div v-if="this.auth?.authority">
          <div class="row" v-if="!this.config?.portList?.find(x => x.name == 'PLC')?.clockStatus">
            <div class="col-12 mt-2">
              <div class="text-center">
                <p class="fw-bold">{{ $t('systemClock') }}</p>
              </div>
            </div>
            <div class="col-6 text-center my-2">
              <span @click="this.systemDate.autoSet = !this.systemDate.autoSet" class="btn bg-success text-white"
                :class="{ 'bg-warning': !this.systemDate.autoSet }">{{ this.systemDate.autoSet ? $t('mode.automatic') :
                  $t('mode.manual') }}</span>
            </div>
            <div class="col-6 text-center my-2">
              <span @click="dateChange()" class="btn bg-info text-white">{{ $t('op.save') }}</span>
            </div>
            <div class="col-12" v-if="!this.systemDate.autoSet">
              <div class="input-area-single m-2">
                <input type="date" name="systemDate" id="systemDate" v-model="systemDate.date" style="height: 50px">
              </div>
            </div>
            <div class="col-12" v-if="!this.systemDate.autoSet">
              <div class="input-area-single m-2">
                <input type="time" name="systemTime" id="systemTime" v-model="systemDate.hour" style="height: 50px">
              </div>
            </div>
          </div>
        </div>
        <ul class="nob-services">
          <div class="row">
            <div class="text-center">
              <p class="fw-bold">{{ $t('services.services') }}</p>
            </div>
            <div class="col-12" v-if="this.authority">
              <li class="service text-center active" @click="this.serviceReboot('boot')">
                <span>{{ $t('rebootCard') }}</span>
              </li>
            </div>
            <div class="col-7" v-if="this.authority">
              <li class="service text-center active" @click="this.serviceReboot('fpr-guardian')">
                <span>{{ $t('services.guardian') }}</span>
              </li>
            </div>
            <div class="col-5" v-if="this.authority">
              <li class="service text-center active" @click="this.serviceReboot('fpr-crm')">
                <span>{{ $t('services.crm') }}</span>
              </li>
            </div>
            <div class="col-12" v-if="services">
              <div class="row justify-content-center">
                <div class="col-6" v-for="(item, index) in services" :key="index">
                  <li class="service text-center" @click="this.serviceReboot(item.service)"
                    :class="{ active: item.counter >= 5 || item.name == 'DB' }">
                    <span>{{ item.name }}</span>
                  </li>
                </div>
              </div>
            </div>

            <div class="text-center">
              <hr />
              <p class="title mb-2 fw-bold">{{ $t('fastAccess') }}</p>
            </div>
            <div class="col-12 mt-2">
              <button type="button" class="btn btn-sm btn-outline-success w-100" @click="this.$router.go()">
                {{ $t('refreshPage') }}
              </button>
            </div>
            <!-- <div class="col-12 mt-2">
              <button type="button" class="btn btn-sm btn-outline-success w-100" :disabled="!this.dataFastAccess.reboot"
                :class="{ 'btn-outline-danger': !this.dataFastAccess.reboot }"
                @click="fastAccess('reboot', `${$t('reboot')}`)">
                {{ $t('reboot') }}
              </button>
            </div> -->
            <div class="col-6 mt-2">
              <button type="button" class="btn btn-sm btn-outline-warning w-100" :disabled="!this.dataFastAccess.reboot"
                :class="{ 'btn-outline-danger': !this.dataFastAccess.reboot }"
                @click="fastAccess('automatic', `${$t('mode.descAutomatic')}`)">
                {{ $t('mode.automatic') }}
              </button>
            </div>
            <div class="col-6 mt-2">
              <button type="button" class="btn btn-sm btn-outline-warning w-100" :disabled="!this.dataFastAccess.reboot"
                :class="{ 'btn-outline-danger': !this.dataFastAccess.reboot }"
                @click="fastAccess('manual', `${$t('mode.descManual')}`)">
                {{ $t('mode.manual') }}
              </button>
            </div>
            <div class="offset-3 col-6 mt-2" v-if="controlPLC?.errorStatus">
              <button type="button" class="btn btn-sm btn-outline-success w-100"
                @click="fastAccess('errorReset', `${$t('errorReset')}`)">
                {{ $t('errorReset') }}
              </button>
            </div>

            <div class="col-12 mt-3">
            <div class="col-12 mt-1">
              <button
                type="button"
                class="btn btn-sm btn-outline-primary w-100"
                :disabled="!dataFastAccess.reboot"
                :class="{ 'btn-outline-danger': !dataFastAccess.reboot }"
                @click="fastAccess(`ileriek`, `${$t(`ileriek`)}`)"
              >
                {{ `${$t(`İleri Ek Tur`)}` }}
              </button>
        
          </div>
  <div class="col-12 mt-1"></div>
          <button
                type="button"
                class="btn btn-sm btn-outline-primary w-100"
                :disabled="!dataFastAccess.reboot"
                :class="{ 'btn-outline-danger': !dataFastAccess.reboot }"
                @click="fastAccess(`geriek`, `${$t(`geriek`)} `)"
              >
                {{ `${$t(`Geri Ek Tur`)}` }}
              </button>
                </div>


            <div class="col-12">
              <div class="text-center mt-3">
                <p class="title mb-2 fw-bold">{{ $t('extraControl') }}</p>
              </div>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-9">
                  <span>{{ $t('items.yonswich1') }}</span>
                </div>
                <div class="col-3">
                  <div class="status-manager">
                    <span class="status" :class="{ 'bg-success': this.controlPLC?.yonlimit1 }"></span>
                  </div>
                </div>
              </div>
            </div>
               <div class="col-12">
              <div class="row">
                <div class="col-9">
                  <span>{{ $t('items.yonswich2') }}</span>
                </div>
                <div class="col-3">
                  <div class="status-manager">
                    <span class="status" :class="{ 'bg-success': this.controlPLC?.yonlimit2 }"></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-9">
                  <span>{{ $t('items.chargelimit') }}</span>
                </div>
                <div class="col-3">
                  <div class="status-manager">
                    <span class="status" :class="{ 'bg-success': this.controlPLC?.chargelimit }"></span>
                  </div>
                </div>
              </div>
            </div>


            
            <div>
              <hr />
            </div>
          </div>
        </ul>
      </div>
    </div>
  </main>
  <footer>
    <div class="content">
      <p>{{ `© 2025` }}</p>
      <p class="fs-2">{{ $t(`spr.errorDesc.${controlPLC?.errorCode}`) }}</p>
      <p>{{ `${this.machineCode} v${this.version}` }}</p>
    </div>
  </footer>
  <div class="specialLoginArea" v-if="!this.auth?.authority">
    <loginPage />
  </div>
</template>

<style>
.specialLoginArea {
  position: absolute;
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
}

:root {
  --c-theme: #5396da;
}
</style>

<script>
import { mapMutations } from 'vuex'
import { AtomSpinner } from 'epic-spinners'
import loginPage from '@/login.vue'

export default {
  components: {
    AtomSpinner,
    loginPage,
  },
  data() {
    return {
      devStatus: false,
      machineCode: 'SPR',
      version: '1.5.2_1',
      time: 0,
      breadcrumb: [this.$t('nav.home')],
      selected_machine: localStorage.selected_machine,
      machineNetwork: false,
      externalToken: undefined,
      externalSelectedMachine: undefined,
      machineAddr: {
        'CFR': 'imom',
        'FPR': 'ibold',
        'SPR': 'ican',
        'CPM': 'colostrum'
      },
      currentMachine: undefined,
      config: undefined,
      spinners: true,
      dataFastAccess: {
        reboot: true,
        errorReset: true
      },
      navOptionsBarShow: false,
      externalFeedingStatus: true,
      systemDate: {
        autoSet: false,
        date: '0000-00-00',
        hour: '00:00:00'
      },
      changeDateStatus: false
    };
  },
  methods: {
    ...mapMutations(['collapse', 'fullScreen', 'navOptionsBar', 'logout']),
    dropdown(event) {
      event.target.parentElement.parentElement.classList.toggle('active')
      event.target.parentElement.parentElement.classList.toggle('open')
    },
    navOptionsBar0() {
      this.navOptionsBar()
      this.navOptionsBarShow = !this.navOptionsBarShow
    },
    async serviceReboot(service) {
      if (await this.$f.alerts_check(this.$t('alerts.restartService'))) {
        this.$axios.post({ uri: '/serviceReboot', valueData: { value: service } })
      }
    },
    async closePopup() {
      this.$router.replace({ query: null })
      this.pageNumber = 1
    },
    async change_lang(lang) {
      localStorage.lang = lang || 'tr'
      this.$router.go()
    },
    async checkByToken() {
      if (this.externalToken?.length > 0) {
        localStorage.token = this.externalToken
        this.$router.push({ query: null })
      }

      if (localStorage.token && localStorage.token != undefined) {
        try {
          var req = await this.$axios.get({ orjUri: '/checkByToken' })
          if (req.newToken) {
            const response = req
            localStorage.token = response?.newToken
            this.$store.state.auth = {
              authority: true,
              role: response?.role,
              mail: response?.mail,
              time: response?.exp,
              authorization: response?.authority,
              tecnicalPersonal: req.authority?.machine?.read ? true : false,
              machines: response?.machines
            }
          } else this.logout()
        } catch (error) {
          if (error.response) this.$alertBox.warning(error.response.data)
          else console.error(error.message)
          this.logout()
          this.$router.go()
        }
      } else this.logout()
      this.spinners = false
      if (this.$route.query.token?.length > 0) this.$router.push({ query: {} })
    },
    async exitAccount() {
      if (await this.$f.alerts_check(this.$t('login.areYouSure_logout'))) {
        this.logout()
      }
    },
    async getMyMachines() {
      const machine_data = await this.$axios.get({ orjUri: '/machines/getMyMachine' })
      this.$store.state.machine_data = machine_data.data
        ?.filter((x) => x.remote_ip != null)
        .sort((a, b) => a.code?.split("-")[1] - b.code.split("-")[1]);
      let machineList = this.$store.state.machine_data

      let findMachine = this.selected_machine ? machineList?.find(x => x.machine_id == this.selected_machine) : machineList.find(x => x.code.split('-')[0] == this.machineCode)

      if (findMachine?.machine_id != this.selected_machine) this.selected_machine = findMachine?.machine_id

      if (!findMachine && machineList?.length > 0) {
        let subDomain = this.machineAddr[machineList[0]?.code?.split('-')[0]] 
        if (window.location.host.split('.')[0] != subDomain && !this.devStatus) {
          this.baseControl(subDomain)
        }
      }
      await this.$socket.connect()
    },
    async baseControl(subDomain) {
      if (this.$store.state.auth.authority) {
        // eslint-disable-next-line
        if (subDomain) {
          const baseURL = `https://${subDomain}.itechrobotics.com.tr`
          if (!this.devStatus) window.location.href = `${baseURL}?externalToken=${localStorage.token}&externalSelectedMachine=${this.selected_machine}`
        }
        else console.log('subDomain olmadığı içinyönlendirme yapılmayacak.')
      }
    },
    async fastAccess(type, desc) {

      if (await this.$f.alerts_check(this.$t('alerts.n_areYouSure', { name: type }))) {
        if (type == "reboot") {
          this.dataFastAccess.reboot = false;
          this.$axios.post({ port: 3020, uri: '/plc', valueData: { type: 'M', addr: 43, value: 1, after: 0 } });
          setTimeout(() => {
            this.dataFastAccess.reboot = true;
          }, 5000);
        }
        else if (type == "manual") this.$axios.post({ port: 3020, uri: '/plc', valueData: { type: 'M', addr: 12, value: 1 } });
        else if (type == "automatic") this.$axios.post({ port: 3020, uri: '/plc', valueData: { type: 'M', addr: 12, value: 0 } });
        else if (type == "errorReset") this.$axios.post({ port: 3020, uri: '/plc', valueData: { type: 'M', addr: 174, value: 1, after: 0 } });
        else if (type == "ileriek") this.$axios.post({ port: 3020, uri: '/plc', valueData: { type: 'M', addr: 10, value: 1, after: 0 } });
        else if (type == "geriek") this.$axios.post({ port: 3020, uri: '/plc', valueData: { type: 'M', addr: 11, value: 1, after: 0 } });
      
        this.$alertBox.info(this.$t('op.success', { name: desc }))
      }
    },
  },
  async mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    this.externalToken = urlParams.get('externalToken')
    this.externalSelectedMachine = urlParams.get('externalSelectedMachine')

    await this.checkByToken();
    if (Number(this.externalSelectedMachine)) {
      localStorage.selected_machine = Number(this.externalSelectedMachine)
      this.$router.go()
    }
    await this.getMyMachines()
    if (window.innerWidth <= 960) {
      document.querySelector('body').classList.add('collapse')
    }

    if (this.selected_machine != null && this.selected_machine != undefined && this.authority) {
      this.config = await this.$axios.get({ port: 4000, uri: '/config' })
      const firstAlert = setInterval(async () => {
        this.config = await this.$axios.get({ port: 4000, uri: '/config' })
        if (this.config?.producer) clearInterval(firstAlert)
        else this.$alertBox.warning(this.$t('alerts.awaitMachine'))
      }, 5000)
    }
    if (this.authority) {
      this.$store.state.errorCodeDesc = await this.$axios.get({ uri: '/systemlog/errordesc' })
      const errorCodeDescInterval = setInterval(async () => {
        if (this.$store.state.errorCodeDesc != undefined) clearInterval(errorCodeDescInterval)
        else this.$store.state.errorCodeDesc = await this.$axios.get({ uri: '/systemlog/errordesc' })
      }, 5000)
    }

    const configInterval = setInterval(async () => {
      if (this.config) {
        this.spinners = false
        this.$store.state.producer = this.config.producer
        this.$store.state.systems = this.config.systems
        this.$store.state.roboConfig.code = `${this.config?.type || 'CFR'}_${this.config?.sub_id?.toString().padStart(4, '0')}_${this.config?.city}`;
        if (this.$store.state?.producer) document.documentElement.style.setProperty('--c-theme', this.$store.state.producer.color)
        this.$store.state.roboConfig.locationCount = Number(this.config?.sub_id?.toString()?.charAt(this.config?.sub_id?.toString().length - 1)) || 4
        clearInterval(configInterval)
      } else if (this.authority) this.config = await this.$axios.get({ port: 4000, uri: '/config' })
    }, 1000)

    setInterval(
      () => {
        this.checkByToken()
      },
      3 * 60 * 1000
    )
    setInterval(() => {
      this.time = this.$store.state.auth.time - Number((new Date().getTime() / 1000).toFixed())
    }, 1000)
  },
  computed: {
    license() {
      return this.$store.state.roboConfig.license
    },
    stationMonitoring() {
      return this.$store.state.stationMonitoring
    },
    services() {
      return this.$store.state.services
    },
    stationCount() {
      return this.$store.state.roboConfig.stationCount
    },
    controlPLC() {
      return this.$store.state.controlPLC
    },
    auth() {
      return this.$store.state.auth
    },
    authority() {
      return this.$store.state.auth?.authority
    },
    producer() {
      return this.$store.state.producer
    },
    machine_data() {
      return this.$store.state.machine_data
    },
    authorization() {
      return this.$store.state.auth?.authorization || {}
    }
  },
  watch: {
    async selected_machine() {
      if (this.$store.state.auth.authority && this.selected_machine != undefined) {
        let findMachine = this.$store.state.machine_data?.find(x => x.machine_id == this.selected_machine)
        let subDomain = this.machineAddr[findMachine?.code?.split('-')[0]] 
        if (window.location.host.split('.')[0] == subDomain || this.devStatus) {
          localStorage.selected_machine = this.selected_machine
          this.$router.go()
        }
        else this.baseControl(subDomain)
      }
    }
  }
}
</script>
